/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import React from 'react';

export default createSvgIcon(
    <path
        transform="scale(Infinity, Infinity)"
        fill="currentColor"
        fillRule="evenodd"
        d="M1.5 3C.6716 3 0 3.6716 0 4.5v15c0 .8284.6716 1.5 1.5 1.5h21c.8284 0 1.5-.6716
        1.5-1.5v-15c0-.8284-.6716-1.5-1.5-1.5h-21ZM12 12.5122 2.6524 4.5h18.6952L12 12.5122ZM1.5 18.4393V5.4878l6.9739
        5.9776L1.5 18.4393ZM2.5607 19.5h18.8786l-7.0555-7.0555L12 14.4878l-2.3839-2.0433L2.5607
        19.5Zm12.9654-8.0346L22.5 18.4393V5.4878l-6.9739 5.9776Z"
        clipRule="evenodd"
    />,
    'Email'
);
